import React, { useState, useEffect } from 'react';
import { PlayFab } from './services/PlayFab'; // Import PlayFab service
import './SubscribePage.css'; // Import the CSS file

const SubscribePage: React.FC = () => {
  const [discountCode, setDiscountCode] = useState('');
  const [playfabId, setPlayfabId] = useState<string | null>(null); // State for PlayFab ID
  const [error, setError] = useState<string | null>(null);

  // The base Payment Link URL you generated
  const paymentLinkUrl = 'https://buy.stripe.com/14k14o4e3f3RcYE000'; // Updated Link

  useEffect(() => {
    // Get PlayFab ID when the component mounts
    const id = PlayFab.getPlayerId();
    if (id) {
      setPlayfabId(id);
    } else {
      // Handle case where PlayFab ID is not available (user not logged in?)
      console.error('Could not retrieve PlayFab ID. User might not be logged in.');
      // Optionally redirect to login or show a message
      setError('Could not retrieve user ID. Please log in.');
    }
  }, []); // Empty dependency array ensures this runs only once on mount

  const handleSubscribe = () => {
    if (!playfabId) {
      setError('Cannot subscribe without PlayFab ID. Please log in.');
      return;
    }

    setError(null);

    // Start with client_reference_id
    let finalUrl = `${paymentLinkUrl}?client_reference_id=${encodeURIComponent(playfabId)}`;

    // Check if the user entered any text in the discount code field
    if (discountCode) {
      console.log(`Passing user-entered discount code as prefilled_promo_code: ${discountCode}`);
      // Use the correct parameter name: prefilled_promo_code, appended with &
      finalUrl += `&prefilled_promo_code=${encodeURIComponent(discountCode)}`;
    }

    console.log('Redirecting to Stripe:', finalUrl);
    window.location.href = finalUrl;
  };

  if (playfabId === null && !error) { // Show loading only if no error yet
    // Optionally show a loading state or message while fetching ID
    return <div>Loading user information...</div>;
  }

  return (
    <div className="subscribe-page-container">
      <h1>Subscribe</h1>
      {error && <p style={{ color: 'red' }}>Error: {error}</p>}

      {/* Pricing Table */}
      <table className="pricing-table">
        <thead>
          <tr>
            <th>Feature</th>
            <th>Free</th>
            <th>Premium</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Analysis per Day</td>
            <td>2</td>
            <td>Unlimited</td>
          </tr>
          <tr>
            <td>Tournament Analysis</td>
            <td>❌</td>
            <td>✅</td>
          </tr>
          <tr>
            <td>Heads-Up Analysis</td>
            <td>❌</td>
            <td>✅</td>
          </tr>
          <tr>
            <td>Level Up Rewards</td>
            <td>❌</td>
            <td>✅</td>
          </tr>
          <tr>
            <td>PreFlop Charts</td>
            <td>❌</td>
            <td>✅</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>Price per Month</td>
            <td>Free</td>
            <td>$30</td>
          </tr>
        </tfoot>
      </table>
      {/* End Pricing Table */}

      <div>
        <label htmlFor="discountCode">Discount Code:</label>
        <input
          type="text"
          id="discountCode"
          value={discountCode}
          onChange={(e) => setDiscountCode(e.target.value)}
          placeholder="Enter discount code (optional)"
          disabled={!playfabId} // Disable if not logged in
        />
      </div>
      <button onClick={handleSubscribe} disabled={!playfabId}>
        Subscribe Now
      </button>
      {!playfabId && <p>Please log in to subscribe.</p>} 
    </div>
  );
};

export default SubscribePage; 